export function toMonthFormat(date) {
	let month = `${date.getMonth() + 1}`.padStart(2, '0');
	let year = date.getFullYear();
	return `${year}-${month}`;
}

export function addMonths(date, amount) {
	var newDate = new Date(date.valueOf());
	newDate.setMonth(newDate.getMonth() + amount);
	return newDate;
}
